import { getFiles } from './base';
import { generateUrl } from '@nextcloud/router';
import { showError, showSuccess } from '@services/utils/dialog';
import axios from '@nextcloud/axios';

import { API } from '@services/API';
import { translate as t } from '@services/l10n';
import { routes } from '@services/router';

import type { RouteLocationNormalized } from 'vue-router';
import type { ClusterTypes, IPhoto } from '@typings';

/**
 * Open the files app with the given photo
 * Opens a new window.
 */
export async function viewInFolder(photo: IPhoto, opts: { route: RouteLocationNormalized }) {
  if (!photo) return;
  const files = await getFiles([photo], { route: opts.route });
  if (files.length === 0) return;

  const url = viewInFolderUrl(files[0]);
  window.open(url, '_blank');
}

/**
 * Gets the view in folder url for the given file.
 */
export function viewInFolderUrl({ filename, fileid }: { filename: string; fileid: number }) {
  // ensure dirPath starts with a slash
  let dirPath = filename.slice(0, filename.lastIndexOf('/'));
  if (!dirPath.startsWith('/')) {
    dirPath = `/${dirPath}`;
  }

  return API.Q(generateUrl('/apps/files/'), {
    dir: dirPath,
    scrollto: fileid,
    openfile: fileid,
  });
}

/**
 * Set the cluster cover image
 *
 * @param photo The photo to set as the cover
 */
export async function setClusterCover(photo: IPhoto, opts: { route: RouteLocationNormalized }): Promise<boolean> {
  if (!photo) return false;

  // Get cluster type from route name (fragile)
  const clusterType = opts.route.name as ClusterTypes;

  // Get other parameters
  const { fileid } = photo;
  let { user, name } = opts.route.params;

  const routeName = opts.route.name?.toString();
  if (routeName === routes.Recognize.name || routeName === routes.Albums.name) {
    name = `${user}/${name}`;
  }

  try {
    await axios.post(API.CLUSTER_SET_COVER(clusterType), { name, fileid });
    showSuccess(t('memories', 'Cover image set successfully'));
    return true;
  } catch (err) {
    showError(t('memories', 'Failed to set cover image'));
    console.error(err);
    return false;
  }
}
